import policiesActions from "./policiesActions";

export default policiesActions;
